<div class="stock-dialog">
  <header class="stock-dialog__header">
    <div>
      <span>DISPONIBILIDAD</span>
      <h2>Algunos productos no tienen existencia suficiente</h2>
    </div>
    <button type="button" mat-dialog-close class="stock-dialog__close" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <mat-dialog-content class="stock-dialog__content">
    <p>
      Lo sentimos, no podemos completar tu pedido porque algunos productos ya no cuentan con existencia suficiente.
      Revisa los siguientes productos y ajusta tu carrito para continuar.
    </p>

    <article class="stock-dialog__product" *ngFor="let product of data.products">
      <img [src]="product.urlFoto || defaultImage" [alt]="product.nombre">
      <div>
        <strong>{{ product.nombre }}</strong>
        <span *ngIf="product.presentacion">{{ product.presentacion }}</span>
        <span>Cantidad solicitada: {{ product.cantidadSolicitada }}</span>
        <span *ngIf="product.existencia !== undefined && product.existencia !== null">Existencia reportada: {{ product.existencia }}</span>
        <span *ngIf="product.precio !== undefined && product.precio !== null">Precio: {{ product.precio | currency:'USD':'symbol':'1.2-2' }}</span>
        <span class="stock-dialog__id">Producto #{{ product.idProducto }}</span>
      </div>
    </article>
  </mat-dialog-content>

  <div class="stock-dialog__actions">
    <button type="button" mat-raised-button class="stock-dialog__button" (click)="reviewCart()">
      Revisar mi carrito
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
